import UserPreference, {
  getDefaults as getUserPreferenceDefaults,
  UserPreferenceOptions,
  UserPreferenceType,
} from 'models/UserPreference';
import { DischargeCalendarView } from 'stores/dischargeCalendarStore';

export type DischargeCalendarFilterValue = {
  currentView?: DischargeCalendarView;
  [key: string]: any;
};

export interface DischargeCalendarFilterOptions extends UserPreferenceOptions {
  type: UserPreferenceType.DISCHARGE_CALENDAR_FILTER;
  value: DischargeCalendarFilterValue;
}

export function getDefaults(): DischargeCalendarFilterOptions {
  return {
    ...getUserPreferenceDefaults(),
    type: UserPreferenceType.DISCHARGE_CALENDAR_FILTER,
    value: {},
  };
}

export default class DischargeCalendarFilter extends UserPreference {
  declare value: DischargeCalendarFilterValue;

  constructor(options: Partial<DischargeCalendarFilterOptions> = {}) {
    const opts = { ...getDefaults(), ...options };

    super(opts);

    this.value = opts.value;
  }
}
